import { paginationSchema } from '~/components/Pagination/Pagination.schema';
import { orderingSchema } from '~/hooks/useSortableTable';
import { z } from 'zod';

export const querySchema = z
  .object({
    search: z.string().default(''),
  })
  .merge(paginationSchema)
  .merge(orderingSchema);
